var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
/**
 * It is a helper to create a readable breadcrumb for users
 * @param replaceFragment - Usually it s appBarActions.replaceFragment. It's a function called with an map to replace ids by texts
 * @param data the Fragments to replace
 */
export var useReplaceFragments = function (replaceFragment, data) {
    var location = useLocation();
    useEffect(function () {
        data.forEach(function (item) {
            var _a;
            if (item[0] && item[1]) {
                replaceFragment((_a = {},
                    _a[item[0]] = item[1],
                    _a));
            }
        });
    }, __spreadArray(__spreadArray([location.pathname], data.map(function (i) { return i[1]; })), data.map(function (i) { return i[2]; })));
};
function withData(item, fn) {
    if (item.tag === "with-data") {
        return fn(item);
    }
    return undefined;
}
/**
 * It is a helper to create a readable breadcrumb for users
 * @param fetchState - It's the state of fetch, that we receive from useFetchOne
 * @param getId - It's a function that given the loaded state you must return object id
 * @param getText - It's a function that given the loaded state you must return a meaning text to appear in Breadcrumb
 */
export function mapFragmentReplace(fetchState, getId, getText) {
    return [
        withData(fetchState, getId),
        withData(fetchState, getText),
        fetchState.tag,
    ];
}
//# sourceMappingURL=useReplaceFragmets.js.map